/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, imageTypes, replacePXinStringWithEM } from 'utils/styles';



// ===================== ANIMATION : TOP : PROGRESS BAR / SHARE SET ICONS ===================== //
const aniProgressBarShareTopResult = {
    // ~~~~~~~~~~~~~~~~~~~~~ RESULT STATE ~~~~~~~~~~~~~~~~~~~~~ //
    '& .resultelements': {
        height: 'auto',
        zIndex: '2',
        '& .progressbar.type-result': {
            animationName: 'fadeInDown',
            animationDelay: '1.3s',
            animationDuration: '.3s',
            animationFillMode: 'forwards'
        },
        '& .rewardsfeedback': {
            '& .icon': {
                animationName: 'fadeInDown',
                animationDelay: '1.8s',
                animationDuration: '.2s',
                animationFillMode: 'forwards'
            },
            '& .text': {
                animationName: 'fadeInLeft',
                animationDelay: '2.3s',
                animationDuration: '.2s',
                animationFillMode: 'forwards'
            }
        },
        '& .facebook': {
            animationName: 'fadeInDown',
            animationDelay: '2.6s',
            animationDuration: '.5s',
            animationFillMode: 'forwards'
        },
        '& .twitter': {
            animationName: 'fadeInDown',
            animationDelay: '2.9s',
            animationDuration: '.5s',
            animationFillMode: 'forwards'
        }
    }
};



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export { aniProgressBarShareTopResult };